module.exports = __webpack_public_path__ + "static/media/green-add-driver.dd29f490.svg";